export default function RadiusGenerate(radius) {
    return (`
        -o-border-radius: ${radius};
        -webkit-border-radius: ${radius};
        -ms-border-radius: ${radius};
        -moz-border-radius: ${radius};
        border-radius: ${radius};
    `)
}